import { IFeature } from 'mod/featureV2/interface';

export const animation: IFeature = {
    moduleId: 'animation',
    type: 'animation',
    title: 'animation',
    description: 'Embark on a virtual journey through every intricate detail of our innovative indoor gardening solution. Engage with interactive 3D models, discovering the excitement and endless possibilities of the VGrow Smart Grow Box from the comfort of your screen.',
    space: {
        paddingTop: 78,
        paddingBottom: 78,
    },
    config: {
        frameInterval: 10,
        show3D: 1,
        showAnimation: 1
    },
    list: [
        {
            key: 'Default',
            imageDir: 'asset/width-3840/picture/vgrow-20240102/vgrow01/',
            imageFrom: 0,
            imageEnd: 0,
        },
        {
            key: 'Window',
            imageDir: 'asset/width-3840/picture/vgrow-20240102/vgrow02/',
            imageFrom: 1,
            imageEnd: 75,
        },
        {
            key: 'Door',
            imageDir: 'asset/width-3840/picture/vgrow-20240102/vgrow03/',
            imageFrom: 1,
            imageEnd: 75,
        },
        {
            key: 'Light',
            imageDir: 'asset/width-3840/picture/vgrow-20240102/vgrow04/',
            imageFrom: 1,
            imageEnd: 49,
        },
        {
            key: 'Ventilation',
            imageDir: 'asset/width-3840/picture/vgrow-20240102/vgrow05/',
            imageFrom: 1,
            imageEnd: 74,
        },
    ]
};